module.exports = __webpack_public_path__ + "img/mic.8083eb08.svg";